import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Addresses served as static HTML from public/ (tools/generate-seo-pages.js),
 * not by React. Hosting serves the file before its rewrite to the app, so a
 * page load at one of these addresses never reaches the app; but a click on a
 * React link (transitionTo, <Link>) changes the address without a page load,
 * and used to draw the old React screen of that address, or the 404 screen
 * once the screen was gone. This route turns that click into a page load.
 *
 * /use-case/<slug> are the retired short pages; firebase.json redirects them,
 * and a page load is what lets the redirect happen.
 */
export const STATIC_PAGES = [
  "/about",
  "/use-cases",
  "/use-cases/business-document-translation-services",
  "/use-cases/certified-translation-of-birth-certificate",
  "/use-cases/financial-document-translation",
  "/use-cases/immigration-document-translation-services",
  "/use-cases/legal-document-translation",
  "/use-cases/medical-document-translation",
  "/use-case",
  "/use-case/:slug",
];

// The address the app was loaded at. If it is one of the pages above, Hosting
// had no file for it and served the app instead (a page not yet generated, or
// the dev server): loading it again would loop, so the 404 screen is shown.
const LANDED = window.location.pathname.replace(/\/+$/, "") || "/";

const StaticPage = ({ fallback = null }) => {
  const { pathname, search, hash } = useLocation();
  const here = pathname.replace(/\/+$/, "") || "/";
  const landedHere = here === LANDED;

  useEffect(() => {
    if (!landedHere) window.location.assign(pathname + search + hash);
  }, [landedHere, pathname, search, hash]);

  return landedHere ? fallback : null;
};

export default StaticPage;
